import {WorkspaceColumnDefinitionApiDto} from "../../api/model/rest";
import {option, Option} from "ts-option";
import {isDefined} from "../../utils/Utils";

export class ColumnDefinition {

	sortPath: string;

	constructor(
		public readonly id: string,
		public readonly label: string,
		public readonly type: string,
		public readonly path: string,
		public readonly searchPath: string,
		public readonly sortable: boolean,
		public readonly defaultVisible: boolean,
		public readonly customFieldId: Option<string>,
		public readonly filterable: boolean
	) {
		this.sortPath = getSortPath(type, path);
	}

	static fromJson(json: WorkspaceColumnDefinitionApiDto): ColumnDefinition {
		const filterable = isDefined(json.filterable) ? json.filterable : true;
		return new ColumnDefinition(json.id, json.label, json.type, json.path, json.searchPath, json.sortable,
			json.defaultVisible, option(json.customFieldId), filterable);
	}

	toJson() {
		return {
			id: this.id,
			label: this.label,
			type: this.type,
			path: this.path,
			searchPath: this.searchPath,
			sortable: this.sortable,
			defaultVisible: this.defaultVisible,
			customFieldId: this.customFieldId.orNull,
			filterable: this.filterable
		}
	}
}

function getSortPath(type: string, path: string): string {
	switch (type) {
		case ColumnTypeEnum.Contact:
			return `${path}.name`;
		default:
			return path
	}
}

export enum ColumnTypeEnum {
	String = "STRING",
	Uuid = "UUID",
	Date = "DATE",
	LeadAssignee = "LEAD_ASSIGNEE",
	JobAssignee = "JOB_ASSIGNEE",
	Appointments = "APPOINTMENTS",
	Contact = "CONTACT",
	LeadStatus = "LEAD_STATUS",
	JobStatus = "JOB_STATUS",
	Brand = "BRAND",
	PartnerBrand = "PARTNER_BRAND",
	LeadTag = "LEAD_TAG",
	JobTag = "JOB_TAG",
	Reconciliation = "RECONCILIATION",
	Currency = "CURRENCY",
	Decimal = "DECIMAL",
	Percentage = "PERCENTAGE",
	Long = "LONG",
	PaymentMethod = "PAYMENT_METHOD",
	Creator = "CREATOR",
	Merchant = "MERCHANT",
	BankAccountType = "BANK_ACCOUNT_TYPE",
	LeadCustomField = "LEAD_CUSTOM_FIELD",
	JobCustomField = "JOB_CUSTOM_FIELD",
	User = "USER",
	BillStatus = "BILL_STATUS",
	StatusBoolean = "STATUS_BOOLEAN",
	Boolean = "BOOLEAN",
	UserPhone = "USER_PHONE",
	JobType = "JOB_TYPE",
	InvoicePath = "JOB_INVOICE_PATH",
	JobWarrantyRegistrationStatus = "JOB_WARRANTY_REGISTRATION_STATUS"
}
